module.exports = __webpack_public_path__ + "static/media/lulc_legend.03328fd6.png";